export default {
  top_deck: {
    notes: 'Label for top deck of equipment with type screen',
    message: 'Top',
  },
  bottom_deck: {
    notes: 'Label for bottom deck of equipment with type screen',
    message: 'Bottom',
  },
  delta: {
    notes: 'Label for delta values',
    message: 'Delta',
  },
};
